<template>
    <div id="welcome-email" class="row justify-content-center">
        <div v-if="registration._id" class="col-12 col-md-6">
            <card class="mt-5 mb-5">
                <h3 class="text-center">Confirm Payment</h3>

                <div class="d-flex mb-3" style="gap:20px; align-content: center">
                    <p class="m-0" v-if="registration.event.enablePaypal || registration.event.enableZelle || registration.event.enableStripe">Pay with: </p>
                    <div class="d-flex" style="gap:10px;">
                        <div class="d-flex" style="gap:10px;">
                            <label v-if="registration.event.enablePaypal" @click="paymentMethod = 'paypal'" for="paypal_radio" style="cursor: pointer; display: flex; align-items:center; gap:10px; margin: 0;" :style="`order:${registration.event.paypalDisplayOrder}`">
                                <input type="radio" id="paypal_radio" :checked="paymentMethod == 'paypal'" style="cursor: pointer;" name="payment_mode" value="paypal">
                                <span>Paypal</span>
                            </label>
                
                            <label v-if="registration.event.enableZelle" @click="paymentMethod = 'zelle'" for="zelle_radio" style="cursor: pointer; display: flex; gap:10px; align-items: center; margin: 0;" :style="`order:${registration.event.zelleDisplayOrder}`">
                                <input type="radio" id="zelle_radio" :checked="paymentMethod == 'zelle'" style="cursor: pointer;" name="payment_mode" value="zelle">
                                <span>{{ registration.event.paymentProviderName }}</span>
                            </label>
                            
                            <label v-if="registration.event.enableStripe" @click="paymentMethod = 'stripe'" for="stripe_radio" style="cursor: pointer; display: flex; gap:10px; align-items: center; margin: 0;" :style="`order:${registration.event.stripeDisplayOrder}`">
                                <input type="radio" id="stripe_radio" :checked="paymentMethod == 'stripe'" style="cursor: pointer;" name="payment_mode" value="stripe">
                                <span>Credit/Debit Cards(stripe)</span>
                            </label>

                        </div>
                        <span>( Due: USD {{ registration.due }} )</span>
                    </div>

                </div>

                <div v-if="paymentMethod == 'paypal' && registration.event.enablePaypal">
                    <div class="row" style="margin-top: 50px;">
                        <div class="col d-flex justify-content-center">
                            <paypal
                                currency="USD"
                                :amount="`${registration.due}`"
                                :env="registration.event.paypalSandboxMode ? 'sandbox' : ''"
                                :notify-url="notifyUrl"
                                :invoice-number="`${registration._id}-${timestamp}`"
                                :button-style="{ color: 'blue', size: 'large' }"
                                @payment-completed="onPaymentSuccess"
                                :client="{
                                    sandbox: registration.event.paypalSandboxClientId,
                                    production: registration.event.paypalClientId
                                }"/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <p
                                v-if="registration.event.onlinePaymentProcessingFee"
                                class="text-center font-weight-bold font-italic font"
                                style="font-size: 14px; color: green">
                                    * For Online Payments {{ registration.event.onlinePaymentProcessingFee }}% fee is calculated
                            </p>
                        </div>
                        <div class="col-12">
                            <p                            
                                class="text-center font-weight-bold font"
                                style="font-size: 12px; color:red">
                                    No PayPal account? Click on the 'PayPal Checkout' button and look for 'Pay with Debit Or Credit Card'
                            </p>
                        </div>
                    </div>
                </div>
                <div v-if="paymentMethod == 'zelle' && registration.event.enableZelle" >
                    <div v-html="registration.event.zelleDescription" class="ql-editor"></div>
                </div>
                <div v-if="paymentMethod == 'stripe' && registration.event.enableStripe" >
                    <StripePayment :cancel_url="getCurrentUri + '?cancel=true'" :success_url="getCurrentUri + '?success=true'" :amount="Number(payment_amount)" :registration="registration"/>
                    <div class="col-12">
                        <p
                            v-if="registration.event.onlinePaymentProcessingFee"
                            :class="`text-center font-weight-bold font-italic font`"
                            style="font-size: 14px; color: green">
                                * For Online Payments {{ registration.event.onlinePaymentProcessingFee }}% fee is calculated
                        </p>
                    </div>
                </div>

                
                <div v-if="registration.event.enablePaymentInfo">
                    <div v-html="registration.event.paymentInfo" class="ql-editor"></div>
                </div>
                <div class="d-flex justify-content-end">
                    <!--router-link :to="`/welcome-email/${registration._id}`">Skip to confirmation page</router-link-->
                    <!--router-link :to="`/welcome-email/${registration._id}`">Skip to confirmation page</router-link-->  

                    <el-button
                        type="primary"
                        class="btn btn-round"
                        @click="onSkipToConfirmationPage">
                            <span>Skip</span>                            
                    </el-button>                  

                </div>
            </card>
        </div>
    </div>
</template>

<script>
import Paypal from 'vue-paypal-checkout'
import swal from 'sweetalert2'
import http from '../http.js'
import { mapState } from 'vuex'
import StripePayment from '../components/StripePayment.vue'

export default {
    components: {
    Paypal,
    StripePayment
},
    computed: {
        ...mapState([
            'baseUrl',
            'user',
            'amountToPay'
        ]),
        success(){
            return this.$route.query.success
        },
        cancel(){
            return this.$route.query.cancel
        },
        getCurrentUri(){
          return window.location.href
        },
        
    },
    watch:{
        success(nv){
            if(nv && nv == 'true'){
                this.showSuccessModal()
            }
        },
        cancel(nv){
            if(nv && nv == 'true'){
                this.showCancelModal()
            }
        }
        
    },
    data () {
        return {
            timestamp: new Date().getTime(),
            registration: {},
            notifyUrl: '',
            payment_amount: 0,
            paymentMethod: "paypal",
            due: 0
        }
    },
    async mounted () {
        this.getRegistration()
        if(this.success && this.success == 'true') this.showSuccessModal()
        if(this.cancel && this.cancel == 'true') this.showCancelModal()
        this.paymentMethod = this.getPaymentMethod
    },
    methods: {
        setPaymentMethod(){
            let method = "paypal"
            let methods = []
            if(this.registration.event.enableZelle) methods.push({method: "zelle", order: this.registration.event.zelleDisplayOrder})
            if(this.registration.event.enableStripe) methods.push({method: "stripe", order: this.registration.event.stripeDisplayOrder})
            if(this.registration.event.enablePaypal) methods.push({method: "paypal", order: this.registration.event.paypalDisplayOrder})

            methods.sort((a,b) =>  Number(a.order) - Number(b.order))

            method = methods[0].method
            
            this.paymentMethod = method
        },
        removeQueries(){
            let fullPath = this.$route.fullPath
            fullPath = fullPath.replace("&success=true", "")
            fullPath = fullPath.replace("&cancel=true", "")
            this.$router.replace({ path: fullPath })
        },
        showSuccessModal(){
            this.removeQueries()
            swal.fire('Payment Request Submitted!', 'Please allow us a few minutes while we hear from Stripe. We will email you with the updated status shortly', 'success')
            .then(() => {
                this.$router.push({ name: 'welcome-email', params: { registrationId: this.$route.params.registrationId } })
            })
        },
        showCancelModal(){
            swal.fire('Payment Aborted!', 'Payment did not go through, please try again', 'error')
            .then(() => {
                this.removeQueries()
            })
        },
        getRegistration: async function () {
            try {
                const response = await http.get(`/api/registrations/${this.$route.params.registrationId}?withChildregistrations=true`)
                const registration = response.data.registration

                let due = registration.total - registration.paid
                if (due && registration.paymentType === 'deposit' &&
                    registration.event.allowDeposit &&
                    registration.event.depositAmount ) {
                        due = registration.event.depositAmount
                }
                if (due && registration.paymentType === 'full' &&
                    registration.event.allowDeposit &&
                    registration.event.depositAmount && registration.event.onlinePaymentOnly) {
                        //due = registration.event.depositAmount
                        due = this.payment_amount
                }
                
                due = Number(due)
                this.payment_amount = due

                
                if(registration.checkoutPageAmount){
                    this.payment_amount = registration.checkoutPageAmount
                    due = registration.checkoutPageAmount
                }
                
                if (due && registration.event.onlinePaymentProcessingFee) {
                    due += (due * registration.event.onlinePaymentProcessingFee) / 100
                }
                
                this.registration = {
                    ...registration,
                    due,
                }

                this.setPaymentMethod()

                this.notifyUrl = `${this.baseUrl}api/payments/paypal/${this.registration.event.paypalSandboxMode ? 'sandbox' : 'live'}`
            } catch (e) {
                this.$store.dispatch('handleErrors', e)
                console.log('error getting registration data')
            }

        },
        onPaymentSuccess: function (info) {
            //swal.fire('Paid!', 'Payment successfully made!', 'success')
            //this.$router.push({ name: 'welcome-email', params: { registrationId: this.registration._id } })

            //http.post(`/api/registrations/${this.registration._id}/resend-confirmation-email?host=${window.location.protocol}//${window.location.host}`)
            //if (this.registration.event.onlinePaymentOnly) { 
            //    this.$notify('Successfully registered!')
            //}
            //this.$notify('Confirmation email resent successfully sent!')
                
                if (this.registration.event.onlinePaymentProcessingFee){
                    this.registration.paid = this.registration.paid + ( (parseFloat(this.customAmount)*100)/(100+this.registration.event.onlinePaymentProcessingFee) );
                    
                }else{
                    this.registration.paid = this.registration.paid + parseFloat(this.customAmount);
                }
                
                this.registration.due = this.registration.total - this.registration.paid;
                this.customAmountInput = this.registration.due;
                this.registration.status = 'confirmed'

                swal.fire('Payment Request Submitted!', 'Please allow us a few minutes while we hear from PayPal. We will email you with the updated status shortly', 'success')
                .then(() => {
                    this.$router.push({ name: 'welcome-email', params: { registrationId: this.registration._id } })
                })
                
                // let timerInterval
                // let time = 10
                // swal.fire({
                //     title: 'Payment submitted.',
                //     html: 'Processing. Please wait. <b></b>',
                //     timer: 10000,                
                //     onBeforeOpen: () => {
                //         swal.showLoading()
                //         timerInterval = setInterval(() => {
                //             const content = swal.getContent()
                //             if (content) {
                //                 const b = content.querySelector('b')
                //                 if (b) {
                //                     b.textContent = time
                //                     time--
                //                 }
                //             }
                //         }, 1000)
                //     },
                //     onClose: () => {
                //         clearInterval(timerInterval)
                //     }
                // }).then((result) => {
                //     /* Read more about handling dismissals below */
                //     if (result.dismiss === swal.DismissReason.timer) {
                //         console.log('I was closed by the timer')
                //         this.$router.push({ name: 'welcome-email', params: { registrationId: this.registration._id } })
                //         // http.post(`/api/registrations/${this.registration._id}/resend-confirmation-email?host=${window.location.protocol}//${window.location.host}`)
                //     }
                // })



        },
        onSkipToConfirmationPage: function (info) {
            //swal.fire('Paid!', 'Payment successfully made!', 'success')
            this.$router.push({ name: 'welcome-email', params: { registrationId: this.registration._id } })

            // if (this.user && this.user._id && this.user.admin){
            //     console.log("by admin");
            // }else{
            //     http.post(`/api/registrations/${this.registration._id}/resend-confirmation-email?host=${window.location.protocol}//${window.location.host}`)
            // }

            //if (this.registration.event.onlinePaymentOnly) { 
            //    this.$notify('Successfully registered!')
            //}
            //this.$notify('Confirmation email resend successfully sent!')
        },


    }
}
</script>